import { Controller } from "stimulus"

export default class extends Controller {
  static targets = ["form"]
  static values = { dialogId: String }

  connect() {
    this.formObserver = new MutationObserver(this.formMutated.bind(this))
    this.formObserver.observe(this.formTarget, { childList: true })
  }

  disconnect() {
    this.formObserver?.disconnect()
  }

  populate(event) {
    const { orderId, teamId } = event.currentTarget.dataset
    if (orderId) this.formTarget.querySelector("#user_order_id").value = orderId
    if (teamId) this.formTarget.querySelector("#user_team_id").value = teamId
  }

  formMutated() {
    const hasErrors = this.formTarget.querySelector(".is-invalid, .text-error")
    if (!hasErrors) document.getElementById(this.dialogIdValue)?.close()
  }
}
